import { createFileRoute } from '@tanstack/react-router';
import { Address } from '@/pages';

/**
 * Address Route (Protected)
 * User shipping address management — accessible from Settings
 */
export const Route = createFileRoute('/_authenticated/settings/address')({
  component: Address,
});
